
export default class ExportReportingMensuelDto {
    date;
    dateFin;
}